import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Baseservice } from "./baseservice";
import { AuthenticationService } from "./authentication.service";

import { HttpClient } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class CarrierService extends Baseservice {
  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("carrier", http, authentication);
  }

  processAccountCredit(paymentReq) {
    return this.http.post(`${this.url}/processAccountCredit`, paymentReq);
  }

  getCarrierById(id: number) {
    return this.getRequest(`${this.url}/${id}`);
  }

  listCarrierAccountsByUserId(id: number,pageSize,page) {
    return this.getRequest(`${this.url}/accounts/${id}/${pageSize}/${page}`);
  }
  

  delete(id: number) {
    return this.http.delete(this.url + "/" + id);
  }

  carrierAccountsById(id: number) {
    return this.getRequest(`${this.url}/legal/${id}`);
  }

  processCLegal = (carrier: any) => {
    return this.http.post(`${this.url}/clegal`, carrier);
  };
  processCompanyDetails = (details: any) => {
    //console.log(details);
    return this.http.post(`${this.url}/cdetails`, details);
  };
  processContactDetails = (contactdetails: any) => {
    //console.log(`${this.url}/contact`);
    return this.http.post(`${this.url}/contact`, contactdetails);
  };

  getContactDetails = (id: number) => {
    return this.getRequest(`${this.url}/contact/${id}`);
  };

  processUpdateCompanyDetails = (details: any) => {
    return this.http.post(`${this.url}/cdetails/edit`, details);
  };

  carrierPersonByuserId(id: number) {
    return this.getRequest(`${this.url}/person/${id}`);
  }

  getConsultantByAccount(
    id: number,
    username?: string,
    status?: string,
    role?: number
  ) {
    //console.log("status:" + status);
    //console.log("user_name:" + username);
    //console.log("role:" + role);
    return this.getRequest(
      `${this.url}/consultants/${id}/?username=${username}&status=${status}&role=${role}`
    );
  }

  getConsultMultipleFilters(params: any) {
    return this.http.post(`${this.url}/searchconsultants`, params);
  }

  getCompanyDetailsById(id: number) {
    return this.getRequest(`${this.url}/company/details/${id}`);
  }

  getAccountConfirmationDetailsById(id: number) {
    return this.getRequest(`${this.url}/account/confirmation/${id}`);
  }

  processSubmission = (subObj: any) => {
    return this.http.post(`${this.url}/account/submission`, subObj);
  };

  getCarrierApplications(id: number, PageNum: number, PageSize: number) {
    return this.getRequest(
      `${this.url}/applications/${id}/${PageNum}/${PageSize}`
    );
  }
  getCarrierPermits(
    id: number,
    PageNum: number,
    PageSize: number,
    appid: number
  ) {
    return this.getRequest(
      `${this.url}/permits/${id}/${PageNum}/${PageSize}/${appid}`
    );
  }

  correspondenceToByCarrierId(id: number) {
    return this.getRequest(`${this.url}/users/approval/${id}`);
  }

  searchCarrierAccounts(
    keyword: any,
    PageNum: number,
    PageSize: number,
    sort: number = 0,
    direction: boolean = false
  ) {
    return this.http.post(
      `${this.url}/account/search/${PageNum}/${PageSize}/${sort}/${direction}`,
      keyword
    );
  }

  searchCarrierPermits(
    keyword: any,
    PageNum: number,
    CarrierId: number,
    PageSize: number,
    sort: number = 0,
    direction: boolean = false
  ) {
    return this.http.post(
      `${this.url}/permits/search/${PageNum}/${PageSize}/${CarrierId}/${sort}/${direction}`,
      keyword
    );
  }

  sendApprovalEmail(body: any) {
    return this.http.post(this.url + "/confirmation-approval/", body);
  }
  putApplication(object) {
    let body = object;
    return this.http.put(this.url, body);
  }
  putStatus(object) {
    let body = object;
    return this.http.put(this.url + "/update/status", body);
  }

  putConsultant(object) {
    let body = object;
    return this.http.put(this.url + "/updateconsultant", body);
  }

  approveAccountAndSendNotification(id: number, user: string) {
    return this.getRequest(`${this.url}/send/notification/${id}/${user}`);
  }

  getlisttranscation(custcode: string, DateFrom: Date, DateTo: Date) {
    let url = `${this.url}/transactions/?CustomerCode=${custcode}&DateFrom=${DateFrom}&DateTo=${DateTo}`;
    console.log("Transaction", url);
    return this.getRequest(url);
  }

  getDebtorAccount(custcode: string) {
    // return this.getRequest(this.url+'/transaction/list/'+${id});
    return this.getRequest(`${this.url}/getdebtoraccount/?id=${custcode}`);
  }

  getInvoice(invoicenumber: string) {
    // return this.getRequest(this.url+'/transaction/list/'+${id});
    return this.getRequest(`${this.url}/gettransaction/?id=${invoicenumber}`);
  }

  getUpdateBalance(customerCode) {
    return this.getRequest(`${this.url}/getupdatebalance/${customerCode}`);
  }
  carrierInfo(id: number) {
    return this.getRequest(`${this.url}/information/${id}`);
  }

  //Validation API Calls
  isCompanyExists(companyName: string, id: number = 0) {
    console.log("Posted Company Name ID", id);
    const validationObject = {
      id: id,
      stringValue: companyName,
      intValue: null,
      doubleValue: 0,
    };
    return this.http.post(`${this.url}/iscompanyexists`, validationObject);
  }

  isCompanyNumberExists(companyNumber: string, id: number = 0) {
    console.log("Posted Company Number ID", id);
    const validationObject = {
      id: id,
      stringValue: companyNumber,
      intValue: null,
      doubleValue: 0,
    };
    return this.http.post(
      `${this.url}/iscompanynumberexists`,
      validationObject
    );
  }

  isTaxNumberExists(taxNumber: string, id: number = 0) {
    console.log("Posted Tax ID", id);
    const validationObject = {
      id: id,
      stringValue: taxNumber,
      intValue: null,
      doubleValue: 0,
    };
    return this.http.post(`${this.url}/istaxnumberexists`, validationObject);
  }

  getCompanyDetailsByName(company){
    console.log("Posted Company Name", company)
      return this.http.post(this.url + '/getcompanybyname', company);
  }

  getCompanyDetailsByNumber(company){
    return this.http.post(this.url + '/getcompanybyregnumber', company);
  }

  getHomeAffairsCarrierDetails(id){
    console.log("Posted ID", id);
    return this.http.get(this.url + '/homeaffairs/' + id);
  }

  checkIfComplianceCanBePaidFor(complianceID: number) {
    return this.getRequest(`${this.url}/checkIfComplianceCanBePaidFor/${complianceID}`);
  }

  carrierStatusForApproved(carrier_id: number , status_id: number) {

    //return this.getRequest(`${this.url}/carrierStatusForApproved/${carrier_id}/${status_id}`);
    return this.http.post(`${this.url}/carrierStatusForApproved/${carrier_id}/${status_id}`, null);
  }
}
